<template>
  <div class="row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.campaigns')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-md-12 col-lg-12 ">
      <div class=" row">
        <div class="col-sm-12">
          <chart-bars-card
            v-loading="loading2"
            :chart-data="emailsChart.data"
            :chart-options="emailsChart.options"
            ref="refEmailsChart"
            >
            <div slot="header">
              <p >{{emailsChart.title}}</p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i>
                {{$t('dashboard.nrOfEmails')}}
              </div>
              <p class="totalEmails">{{$t('reports.emailTotal')}} <span>{{totalEmails}}</span></p>
            </div>
          </chart-bars-card>
        </div>
      </div>
      <div class="search-bar">
        <div class="col-sm-12 no-padding">
            <div class="pull-left">
              <el-input v-model="searchQuery" @input="onInput()" :placeholder="$t('reports.search')" class="icon-search"></el-input>
            </div>
            <div class="pull-right">
              <router-link class="btn add " :title="$t('general.add') + ' ' + $t('marketingCampaigns.single')" :to="{ path: '/marketing/campaigns/add'}">
                <img src="/static/img/icons/add.png">
                {{ $t('general.add') }}
              </router-link>
            </div>
          </div>
      </div>
      <div class="card">
        <div class="card-content row">
          <data-tables class="campaign-table campaign-table--with-images width-table"
                    v-loading="loading"
                    :data="tableData"
                    :action-def="defaultActionDef()"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}"
                    :filters="filters"
                    @row-click="goToRecord"
                    style="width: 100%">
            <el-table-column
              :min-width="30"
              :label="$t('marketingCampaigns.image')">
              <template slot-scope="props">
                <div class="image-table">
                  <img v-bind:src="(props.row.image_url)?props.row.image_url[0].url : ''" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="45"
              prop="name"
              :label="$t('marketingCampaigns.name')">
            </el-table-column>
            <el-table-column
              :min-width="30"
              prop="mode"
              :label="$t('marketingCampaigns.mode')">
              <template slot-scope="props">
               {{ $t('campaignsModes.' + props.row.mode) }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="45"
              prop="valid"
              :label="$t('marketingCampaigns.startEnd')">
              <template slot-scope="props">
                {{formatDate(props.row.datetime_validfrom)}} - {{formatDate(props.row.datetime_validto)}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="25"
              prop="name"
              :label="$t('marketingCampaigns.daysLeft')">
              <template slot-scope="props">
                {{getDaysLeft(props.row.datetime_validto) }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="30"
              prop="name"
              :label="$t('marketingCampaigns.timesUsed')">
              <template slot-scope="props">
                {{props.row.counter }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="25"
              :label="$t('marketingCampaigns.status')"
              prop="active">
              <template slot-scope="props">
                <p-switch v-model="props.row.active" type="success" @input="handleActive(props.$index, props.row, $event)"></p-switch>
              </template>
            </el-table-column>
            <el-table-column
              :width="200"
              prop="actions"
              class-name="centered-cell"
              align="center"
              header-align="center"
              :label="$t('marketingCampaigns.actions')">
              <template slot-scope="props">
                <div class="campaign-table__actions">
                  <a class="btn btn-icon-small btn-danger mar-rt-10" :title="$t('general.delete')" :disabled="props.row.is_sending" @click.stop="handleDelete(props.$index, props.row)"><i class="fa fa-trash-o"></i></a>
                  <a
                    class="btn btn-icon-small btn-info mar-rt-10"
                    :title="$t('general.duplicate')"
                    @click.stop="duplicateCampaign(props.row)">
                    <i class="fa fa-copy"></i>
                  </a>
                  <a
                    class="btn btn-icon-small btn-purple mar-rt-10"
                    :title="$t('marketingCampaigns.send')"
                    :disabled="props.row.isDisabledByLastSent || !props.row.active || props.row.mode == 'AUTO'"
                    @click.stop="sendNotif(props.$index, props.row)">
                    <i class="ti-email"></i>
                  </a>
                  <a
                    class="btn btn-icon-small btn-orange mar-rt-10"
                    :title="$t('marketingCampaigns.stopSending')"
                    :disabled="!props.row.is_sending"
                    @click.stop="stopSending(props.row)">
                    <i class="fa fa-ban" aria-hidden="true"></i>
                  </a>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :width="160"
              class-name="centered-cell"
              align="center"
              header-align="center">
                <template slot-scope="props">
                  <div class="edit">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
            </el-table-column>
          </data-tables>
          <el-pagination
            class="active-pagination width-table"
            :total="paginationDef.totalRecords"
            :page-size="paginationDef.perPage"
            :pager-count="pagerCount"
            layout="prev, pager, next, total"
            @current-change="handlePageChange($event)"
            @prev-click="handlePageChange($event)"
            @next-click="handlePageChange($event)">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      ChartBarsCard
      // GeneralTopBar
    },
    watch: {
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        loading2: true,
        actionCol: {
          label: 'Delete',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'danger',
              icon: 'el-icon-delete',
              class: 'btn btn-orange btn-fill'
            },
            handler: (index, row) => {
              this.handleDelete(index, row)
            },
            label: this.$t('general.delete')
          }]
        },
        pagerCount: 5,
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: false
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['name', 'status', 'type']
          }
        ],
        emailsChart: {
          title: '',
          data: {
            labels: [],
            series: []
          },
          options: {
            seriesBarDistance: 20,
            showArea: true,
            height: '300px',
            axisX: {
              position: 'end',
              labelOffset: {
                x: 10,
                y: 10
              },
              showLabel: true,
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            }
          }
        },
        totalEmails: null
      }
    },
    created () {
      this.loadData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.loadData()
      },
      loadData () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.getCampaigns(data)
        this.getEmailCampaignStatistics(data)
      },
      stopSending (row) {
        if (row.is_sending) {
          swal({
            text: this.$t('marketingCampaigns.areYouSureCancelSending') + ' ' + row.name + '?',
            type: 'question',
            showCancelButton: true
          })
          .then((result) => {
            if (result) {
              let data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                id: row.id
              }
              this.apiRequest('/stop-sending-campaign', 'POST', data, (response) => {
                if (response.status) {
                  row.is_sending = false
                  swal(
                    this.$t('marketingCampaigns.campaignStoppedSuccessfuly'),
                    '',
                    'success'
                  ).catch(() => {})
                } else {
                  row.is_sending = true
                  swal(
                    this.$t('validations.wentWrong'),
                    '',
                    'error'
                  ).catch(() => {})
                }
              })
            }
          })
        } else {
          swal(
            row.name + ' ' + this.$t('marketingCampaigns.notBeingSending'),
            '',
            'error'
          ).catch(() => {})
        }
      },
      onInput () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        if (this.searchQuery.length >= 3) {
          data.search = this.searchQuery
          this.getCampaigns(data)
        }

        if (this.searchQuery.length === 0) {
          this.getCampaigns(data)
        }
      },
      handlePageChange (page) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          page: page,
          perPage: this.paginationDef.perPage
        }
        if (this.searchQuery.length >= 3) {
          data.search = this.searchQuery
        }
        this.getCampaigns(data)
      },
      getCampaigns (data) {
        var self = this
        this.loading = true
        this.apiRequest('/campaign', 'GET', data, function (response) {
          if (response.status === true) {
            self.tableData = response.data.data
            self.paginationDef.page = response.data.pagination.page
            self.paginationDef.perPage = response.data.pagination.perPage
            self.paginationDef.totalPages = response.data.pagination.totalPages
            self.paginationDef.totalRecords = response.data.pagination.totalRecords
            self.tableData.forEach((element) => {
              self.$set(element, 'isDisabledByLastSent', self.checkLastSent(element))
            })
          }
          self.$nextTick(function () {
            self.loading = false
          })
        })
      },
      goToRecord (row, column, event) {
        if (column.property !== 'actions' && column.property !== 'active') {
          this.globalGoToRecord(row, event, column, '/marketing/campaigns/edit/')
        }
      },
      duplicateCampaign (row) {
        this.$router.push({
          path: '/marketing/campaigns/add',
          query: { duplicateFrom: row.id }
        })
      },
      handleActive (index, row, e) {
        let actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var notificationTypes = []
            for (let i in row.notification_type) {
              if (row.notification_type[i]) {
                for (let type in row.notification_type[i]) {
                  notificationTypes.push({'type': row.notification_type[i][type]})
                }
              }
            }
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              name: row.name,
              type: row.type,
              mode: row.mode,
              notification_type: JSON.stringify(notificationTypes),
              active: row.active ? 1 : 0
            }
            var self = this
            this.apiRequest('/campaign/' + row.id, 'PUT', data, function (response) {
              if (response.status) {
                swal(
                  self.$t('general.success') + '!',
                  '',
                  'success'
                ).catch(() => {})
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          row.active = !row.active
        })
      },
      sendNotif (index, row) {
        if (row.isDisabledByLastSent) {
          swal(
            this.$t('marketingCampaigns.campaignWasSent') + '!',
            '',
            'info'
          ).catch(() => {})
        } else {
          swal({
            text: this.$t('marketingCampaigns.areYouSureNotif'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('general.yes')
          }).then((result) => {
            this.$nextTick(function () { this.loading = true })
            if (result) {
              var data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                campaign_id: row.id
              }
              var self = this
              this.apiRequest('/queues/notifications', 'POST', data, function (response) {
                self.$nextTick(function () { this.loading = false })
                if (response.status) {
                  swal(
                    '',
                    self.$t('marketingCampaigns.notifSent'),
                    'success'
                  ).catch(() => {})
                  self.$nextTick(() => {
                    var validIndex = self.tableData.findIndex((obj) => { return obj.id === row.id })
                    self.tableData[validIndex].last_sent = response.data.last_sent
                    self.tableData[validIndex].is_sending = true
                    self.tableData[validIndex].isDisabledByLastSent = self.checkLastSent(self.tableData[validIndex])
                  })
                } else {
                  let msg = self.$t('validations.wentWrong')
                  if (response.errors.campaign_id !== undefined) {
                    msg = response.errors.campaign_id
                  }
                  swal(
                    '',
                    msg,
                    'error'
                  ).catch(() => {})
                }
              })
            }
          }).catch(() => {
           //
          })
        }
      },
      handleDelete (index, row) {
        var self = this
        if (!row.is_sending) {
          let question = {
            text: this.$t('marketingCampaigns.areYouSureDelete') + ' ' + row.name + '?',
            type: 'question',
            showCancelButton: true
          }
          if (row.coupon) {
            // the coupon is not deleted with the campaign => the user decides what happens with it
            question = {
              ...question,
              text: question.text + ' ' + this.$t('marketingCoupons.deleteCampaignCouponQuestion', {coupon: row.coupon.name}),
              input: 'radio',
              inputOptions: {
                keep: this.$t('marketingCoupons.keepCouponActive'),
                deactivate: this.$t('marketingCoupons.deactivateCoupon')
              },
              inputValue: 'keep'
            }
          }
          swal(question)
          .then((result) => {
            if (result) {
              var data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              if (row.coupon) {
                data.coupon_action = result === 'deactivate' ? 'deactivate' : 'keep'
              }
              this.apiRequest('/campaign/' + row.id, 'DELETE', data, function (response) {
                if (response.status === true) {
                  swal(
                    '',
                    self.$t('marketingCampaigns.campaignDeleted'),
                    'success'
                  ).catch(() => {})
                  self.tableData.splice(index, 1)
                } else {
                  swal(
                    '',
                    self.$t('validations.wentWrong'),
                    'error'
                  ).catch(() => {})
                }
              })
            }
          }).catch(() => {
            //
          })
        } else {
          swal({
            text: self.$t('marketingCampaigns.cannotDelete'),
            type: 'error',
            showCancelButton: false
          })
        }
      },
      getEmailCampaignStatistics (data) {
        this.loading2 = true
        this.apiRequest('/campaign-email-statistics', 'GET', data, (response) => {
          if (response.status === true) {
            this.emailsChart.data.labels = response.data.label
            this.emailsChart.data.series = [response.data.value]
            this.totalEmails = response.data.total
            this.emailsChart.title = this.$t('reports.emailSend')
            this.$refs.refEmailsChart.initChart()
          }
          this.$nextTick(() => {
            this.loading2 = false
          })
        })
      },
      addZero (i) {
        if (i < 10) {
          i = '0' + i
        }
        return i
      },
      checkLastSent (row) {
        if (row.last_sent && row.last_sent.length) {
          const data1 = new Date(row.last_sent)
          const data2 = new Date()
          const differenceInTime = data2.getTime() - data1.getTime()
          const minutes = Math.floor(differenceInTime / 60000)
          if (minutes < 30) {
            return true
          } else {
            return false
          }
        }
        return false
      }
    }
  }
</script>
<style>
  .btn-icon-small {
    border-radius: 25px !important;
    padding: 7px 5px !important;
  }
  .el-table th > .cell {
    word-break: break-word;
    font-size: 16px;
    font-weight: 500;
  }
  .campaign-table .centered-cell .cell {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .campaign-table .campaign-table__actions {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
  .campaign-table .campaign-table__actions .btn {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    padding: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50% !important;
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Campaigns.vue